<mat-toolbar color="primary" class="toolbar">
    <app-back-button [route]="['/home', 'perfil']" color="secondary"></app-back-button>
    <div>{{ "SKILLS.TITLE" | translate }}</div>
</mat-toolbar>

<mat-card>
    <mat-card-content>
        <button
            [id]="'button_profile-skills_EditarSalvar'"
            mat-mini-fab
            color="primary"
            (click)="toggleEdition()"
            class="edition-button"
        >
            <mat-icon aria-label="label">{{ editMode ? "save" : "create" }}</mat-icon>
        </button>

        <div class="form-container">
            <mat-card>
                <mat-card-content>
                    <mat-chip-list color="primary">
                        <mat-chip
                            *ngFor="let tag of tags"
                            (click)="selectMainTag(tag.name)"
                            [class.selected-chip]="tag.selected"
                            [disabled]="!editMode"
                        >
                            {{ tag.name }}
                        </mat-chip>
                    </mat-chip-list>
                </mat-card-content>
            </mat-card>
        </div>
    </mat-card-content>
</mat-card>
